const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const upperFirst = require('mn-utils/upperFirst');
const withState = require('../../../../../utils/withState');
const {
  MAILSYSTEM_STATE_RUNNING,
} = require('../../../../../constants/mailsystem');
const {
  apiAdminMailSystemRun,
  apiAdminMailSystemPause,
} = require('../../../../../api/admin/mailSystem');
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading');
const CheckboxA = require('../../../../dumb/Checkbox/F');
const ButtonA = require('../../../../dumb/Button/A');


module.exports = withState((setState) => {
  return (state, props) => {
    const onChange = props.onChange || noop;
    const data = props.data || {};
    const {
      error,
      loading,
    } = state;
    const sender = data.sender || '';
    const status = data.state || 'unknown';
    const hasRunning = status === MAILSYSTEM_STATE_RUNNING;


    return (
      <>
        <div className="layoutRow fhaS fvaC">
          <div className="w(|min)380">
            <CheckboxA
              checked={hasRunning}
              label={(<div className="layoutRow fhaS fvaC">
                <div className="wmin220 pl10">
                  {upperFirst(sender)} <span
                    className="o50"
                  >({data.count || 0} / {data.limit || 0})</span>
                </div>
                <div
                  className={'cF00.stoped cF80.paused c0F0.running ' + status}
                >{status}</div>
              </div>)}
            />
          </div>
          <WrapperWithLoading
            loading={loading}
          >
            <div className="layoutRow fhaS fvaC">
              <ButtonA
                disabled={hasRunning}
                className="w100 o50.disabled"
                onClick={() => {
                  setState({
                    loading: true,
                  });
                  apiAdminMailSystemRun({
                    sender,
                    skipError: 1,
                  }).finally((error) => {
                    setState({
                      loading: false,
                      error,
                    });
                    error || delay(onChange);
                  });
                }}
              >Run</ButtonA>
              <ButtonA
                disabled={!hasRunning}
                className="ml10 w100 o50.disabled"
                onClick={() => {
                  setState({
                    loading: true,
                  });
                  apiAdminMailSystemPause({
                    sender,
                    skipError: 1,
                  }).finally((error) => {
                    setState({
                      loading: false,
                      error,
                    });
                    error || delay(onChange);
                  });
                }}
              >Stop</ButtonA>
            </div>
          </WrapperWithLoading>
        </div>
        {
          error ? (
            <div
              className="mt10 hmin40 layoutRow fhaS fvaC ph15 pv5 cF00 bg0 r5"
            >
              <div>
                <div className="f10">Error</div>
                <div>{error.message}</div>
              </div>
            </div>
          ) : null
        }
      </>
    );
  };
}, {});
